import React, {useEffect} from 'react';
import {trackEvent} from '../../tracking/amplitude/TrackingV2';
import {ButtonDropdown, DropdownList, Text} from '@forecast-it/design-system';
import {usePDF} from '@react-pdf/renderer';
import styled from 'styled-components';

export type PDFProps = {
	fileName: string;
	document: React.ReactElement;
};

interface DeliverablesPhasesExportButtonProps {
	pdf: PDFProps;
	exportCSV: () => void;
}

const FullHref = styled.a`
	width: 100%;
	height: 100%;
`;

export const DeliverablesPhasesExportButton = ({pdf, exportCSV}: DeliverablesPhasesExportButtonProps): JSX.Element => {
	const [instance, setPDFDocument] = usePDF({document: pdf.document});
	useEffect(() => setPDFDocument(pdf.document), [pdf.document]);

	const onExportCsv = () => {
		trackEvent('CSV File', 'Exported');
		exportCSV();
	};

	const onExportPdf = () => {
		trackEvent('PDF File', 'Exported');
	};

	return (
		<DropdownList>
			<DropdownList.Trigger>
				<ButtonDropdown emphasis={'medium'} icon={'download'} data-cy={'export-phases'} />
			</DropdownList.Trigger>
			<DropdownList.Content offset={4} width="150px">
				<DropdownList.Item onClick={onExportCsv} data-cy={'export-csv'}>
					<Text>Export CSV</Text>
				</DropdownList.Item>
				<DropdownList.Item data-cy={'export-pdf'}>
					<FullHref href={instance.url as string} download={pdf.fileName} onClick={onExportPdf}>
						<Text>Export PDF</Text>
					</FullHref>
				</DropdownList.Item>
			</DropdownList.Content>
		</DropdownList>
	);
};

export default DeliverablesPhasesExportButton;
